// Shared constants for the Feedback view and its sub-components.

// ─── Rating ───────────────────────────────────────────────────────────────────

export const RATING_VALUES = ['positive', 'neutral', 'negative'];

export const RATING_LABELS = {
  positive: 'Positive',
  neutral:  'Neutral',
  negative: 'Negative',
};

export const RATING_COLOURS = {
  positive: { bg: '#f0fdf4', color: '#16a34a' },
  neutral:  { bg: '#fef9c3', color: '#ca8a04' },
  negative: { bg: '#fef2f2', color: '#dc2626' },
};

// ─── Filter defaults ──────────────────────────────────────────────────────────

export const FEEDBACK_FILTER_DEFAULTS = {
  ratings:    [],
  dateFrom:   '',
  dateTo:     '',
  hasMessage: 'all',
};

export const HAS_MESSAGE_OPTIONS = [
  { value: 'all',     label: 'All' },
  { value: 'with',    label: 'With message' },
  { value: 'without', label: 'Without message' },
];

// ─── Table ────────────────────────────────────────────────────────────────────

export const PAGE_SIZES = [25, 50, 100];

export const COLS = [
  { key: 'date_created', label: 'Date Posted',  sortable: true  },
  { key: 'rating',       label: 'Rating',       sortable: true  },
  { key: 'error_type',   label: 'Error Type',   sortable: true  },
  { key: 'comment',      label: 'Comment',      sortable: false },
  { key: 'email',        label: 'Commented By', sortable: true  },
  { key: '_actions',     label: '',             sortable: false },
];

// ─── UI text ──────────────────────────────────────────────────────────────────

export const TEXT = {

  // Page header
  pageTitle:    'Feedback',
  pageSubtitle: 'View and manage user feedback',

  // Metric cards
  metricPositive: 'Positive Comments',
  metricNeutral:  'Neutral Comments',
  metricNegative: 'Negative Comments',

  // Search
  searchPlaceholder: 'Search by comment or email...',

  // Filters button
  filtersBtn: 'Filters',

  // Filter panel sections & controls
  filterRating:   'Rating',
  filterDate:     'Date posted',
  filterHasMsg:   'Has message',
  filterDateFrom: 'From',
  filterDateTo:   'To',
  filterClearAll: 'Clear all',
  filterApply:    'Apply',

  // Table states
  tableLoading: 'Loading\u2026',
  tableEmpty:   'No feedback found.',

  // Pagination
  rowsPerPage: 'Rows per page',
  pageLabel:   'Page',
  pageOf:      'of',

  // Row actions
  actionDelete: 'Delete',

  // Delete confirmation modal
  deleteTitle: 'Delete Feedback Item',
  deleteBody:  'Are you sure you want to delete this item?',
  deleteBtn:   'Delete',

};
